var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"popper-class":"rp-tooltip-style","effect":"dark","content":_vm.displayContent,"placement":"top-end"}},[_c('i',{staticClass:"el-icon-copy-document",on:{"click":_vm.clickedIcon}})])}
var staticRenderFns = []

export { render, staticRenderFns }